export default "__VITE_ASSET__0f1948dc__"